import {useMemo} from 'react';
import assert from 'assert-ts';
import type {AgentSubType} from 'types';
import type {DeleteAgentFunc, SaveAgentFunc} from 'services/agent';
import {useAgent} from 'services/agent';
import type {AgentState} from 'services/agent/reducer/agentReducer';
import type {AgentIdParam, NewAgentParam} from '../types';

export const useNewOrExistingAgent = ({
  agentId,
  agentType,
  suggestion,
}: NewAgentParam | AgentIdParam):
  | {
      /** Loaded agent, with limit works data */
      agent: AgentState;
      agentType?: undefined;
      suggestion?: undefined;
      saveAgent: SaveAgentFunc;
      deleteAgent: DeleteAgentFunc;
    }
  | {
      agent?: undefined;
      suggestion: string;
      agentType: AgentSubType;
      saveAgent: SaveAgentFunc;
      deleteAgent: DeleteAgentFunc;
    } => {
  const {
    agentEmptyWorks: existingAgent,
    saveAgent,
    deleteAgent,
  } = useAgent(agentId, 'full', 'mentionedIn');

  return useMemo(() => {
    if (agentId) {
      return {agent: existingAgent, saveAgent, deleteAgent};
    }

    return {
      agentType: assert(agentType, 'agentType is required'),
      suggestion: suggestion ?? '',
      saveAgent,
      deleteAgent,
    };
  }, [agentId, agentType, deleteAgent, existingAgent, saveAgent, suggestion]);
};
